module.exports = __webpack_public_path__ + "static/media/new-patient.b2a3f230.pdf";